import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './EmployeesPage.css';
export default function EmployeeBreadcrumbs({ section = 'Empleados', employeeName }) {
  const location = useLocation();
  if (section === 'Empleados' && !employeeName && !location.state?.employeeSection) return null;
  return <nav className="employees-breadcrumbs" aria-label="Ruta de navegación">
    <Link to="/sueldos" state={{ employeeSection: false }}>Personal</Link><span aria-hidden="true">→</span>
    {employeeName ? <><Link to={location.state?.returnTo?.startsWith("/sueldos/empleados?")?location.state.returnTo:"/sueldos/empleados"} state={{ employeeSection: true }}>Empleados</Link><span aria-hidden="true">→</span><span aria-current="page">{employeeName}</span></> : <span aria-current="page">{section}</span>}
  </nav>;
}
